import {Component, Inject, OnInit} from '@angular/core';
import {EndUserTerminal} from '@app/services/end-user-terminal';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {getTerminalCategories, getTerminalTypes} from '@app/shared/utils/terminal-utils';
import {Trunk} from '@gt-api';
import {GtDirectoryService} from '@app/services/gt-directory.service';
import {catchError, tap} from 'rxjs/operators';
import {EMPTY} from 'rxjs';
import {GtNotificationService} from '@app/services/gt-notification.service';

export interface EndUserTerminalDialogData {
  entry: EndUserTerminal;
  trunkProviders: string[];
  trunks: Map<string, Array<Trunk>>;
  editMode: boolean;
}
@Component({
  selector: 'gt-end-user-terminal-editor',
  templateUrl: './end-user-terminal-editor.component.html',
  styleUrls: ['./end-user-terminal-editor.component.scss']
})
export class EndUserTerminalEditorComponent implements OnInit {
  endUserTerminal: EndUserTerminal;
  editMode: boolean;
  terminalTypes = getTerminalTypes().filter(t => t.id !== 2); // remove Lync as a choice
  terminalCategories = getTerminalCategories();
  trunkProviders: string[];
  trunks: Map<string, Array<Trunk>>;

  constructor(
    private dialogRef: MatDialogRef<EndUserTerminalEditorComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: EndUserTerminalDialogData,
    private notificationService: GtNotificationService,
    private gtDirectoryService: GtDirectoryService
  ) {}

  ngOnInit(): void {
    this.endUserTerminal = this.dialogData.entry;
    this.editMode = this.dialogData.editMode;
    this.trunkProviders = this.dialogData.trunkProviders;
    this.trunks = this.dialogData.trunks;
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onSaveClick() {
    const organization = this.endUserTerminal.organization;
    const login = this.endUserTerminal.login;
    const action$ = this.editMode
      ? this.gtDirectoryService.editEndUserTerminal(organization, login, this.endUserTerminal)
      : this.gtDirectoryService.addEndUserTerminal(organization, login, {
          ...this.endUserTerminal,
          fullNumber: this.endUserTerminal.fullNumber.replace(/\D/g, '')
        });
    action$
      .pipe(
        tap(() => {
          this.notificationService.showSuccessMessage();
          this.dialogRef.close(true);
        }),
        catchError(error => {
          this.notificationService.showErrorMessage(error);
          return EMPTY;
        })
      )
      .subscribe();
  }
}
